/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Variability_Index_RangeInputs */

const en_exp_variability_index_range = /** @type {(inputs: Exp_Variability_Index_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1.00–1.05: smooth like a time trial. 1.05–1.15: rolling roads or a group ride. Above 1.15: lots of surges, like a crit or a hilly loop.`)
};

const de_exp_variability_index_range = /** @type {(inputs: Exp_Variability_Index_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,00–1,05: gleichmäßig wie im Zeitfahren. 1,05–1,15: wellige Straßen oder Gruppe. Über 1,15: viele Antritte, wie im Kriterium oder auf einer Bergrunde.`)
};

/**
* | output |
* | --- |
* | "1.00–1.05: smooth like a time trial. 1.05–1.15: rolling roads or a group ride. Above 1.15: lots of surges, like a crit or a hilly loop." |
*
* @param {Exp_Variability_Index_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_variability_index_range = /** @type {((inputs?: Exp_Variability_Index_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Variability_Index_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_variability_index_range(inputs)
	return de_exp_variability_index_range(inputs)
});